module.exports = __webpack_public_path__ + "static/media/dashboard.44391d06.svg";